export const PAGE_SIZE = 50;

// .btn-* classes are sized as page-level pill CTAs (margin, generous
// padding, --text-base) — inside a dense table row that inflates row
// height and looks oversized, so table-row buttons override to a compact
// size that still uses the shared variant colours.
export const TABLE_BTN: React.CSSProperties = {
  margin:       0,
  padding:      '3px 10px',
  fontSize:     'var(--text-xs)',
  lineHeight:   1.3,
};
